import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const getMobileCode = (payload) =>
  httpClient.get(apis.MALL_SMS_REGISTER + payload.mobile, {
    params: { captcha: payload.captcha },
    ignore: true,
  });
export const getMallGoodQrcode = ({ goodId, limitYear }) =>
  httpClient.get(apis.GET_MALL_GOOD_QRCODE + goodId + '/' + limitYear);
export const getMallPublicGoodQrcode = ({ goodId, source }) =>
  httpClient.get(apis.getMallPublicGoodQrcode({ goodId }), {
    params: { source },
  });
//export const getMallGoodQrcodePayed = ({ goodId, source }) =>
//  httpClient.get(apis.GET_MALL_GOOD_QRCODE + goodId, {
//    params: { source },
//  });
export const checkMallGoodQrcode = (payload) =>
  httpClient.post(apis.CHECK_MALL_GOOD_QRCODE, payload, { ignore: true });
export const makeMallYzQrcode = (payload) =>
  httpClient.post(apis.MAKE_MALL_YZ_QRCODE, payload, { ignore: true });
export const makeMallWechatQrcode = (payload) =>
  httpClient.post(apis.makeMallWechatQrcode(), payload, { ignore: true });
export const checkMallScanQrcode = (payload) =>
  httpClient.get(apis.CHECK_MALL_SCAN_QRCODE + payload.qrId + '/' + payload.qrType, {
    params: { vendorId: payload.vendorId },
    ignore: true,
    ignoreLoading: true,
  });
//export const getWebAlipayPageSnaplet = (payload) =>
//  httpClient.get(apis.GET_WEB_ALIPAY_PAGE_SNAPLET, payload, { ignore: true });
//export const getWebAlipayWapSnaplet = (payload) =>
//  httpClient.get(apis.GET_WEB_ALIPAY_WAP_SNAPLET, payload, { ignore: true });
export const makeMallAlipaySnapletHtml = (payload) =>
  httpClient.post(apis.MAKE_MALL_ALIPAY_HTML, payload, { ignore: true });
export const makeMallAlipaySnapletTradeHtml = (payload) =>
  httpClient.get(apis.makeMallAlipaySnapletTradeHtml(payload), { ignore: true });
//export const getMallAlipayNotification = (payload) =>
//  httpClient.post(apis.GET_MALL_ALIPAY_NOTIFICATION, payload, { ignore: true });
export const makeMallHaierUrl = (payload) =>
  httpClient.post(apis.MAKE_MALL_HAIER_URL, payload, { ignore: true });
export const makeMallHaierLoanTradeUrl = (payload) =>
  httpClient.get(apis.makeMallHaierLoanTradeUrl(payload), { ignore: true });
export const mallAddForFree = (payload) =>
  httpClient.post(apis.MALL_ADD_FOR_FREE, payload, { ignore: true });
export const mallAddForTaobao = (payload) =>
  httpClient.post(apis.MALL_ADD_FOR_TAOBAO, payload, { ignore: true });
export const checkButtonMallScanQrcode = (payload) =>
  httpClient.get(apis.CHECK_BUTTON_MALL_SCAN_QRCODE + payload.qrId + '/' + payload.qrType, {
    params: { vendorId: payload.vendorId },
    ignore: true,
    ignoreLoading: true,
  });
export const makeMallPaypalUrl = (payload) =>
  httpClient.post(apis.MAKE_MALL_PAYPAL_URL, payload, { ignore: true });
export const getMallCouponList = (goodId) =>
  httpClient.get(apis.GET_MALL_COUPON_LIST + goodId, { ignore: true, ignoreLoading: true });
export const getMallTradeCouponList = (payload) =>
  httpClient.get(apis.getMallTradeCouponList(payload), { ignore: true, ignoreLoading: true });

export const getMallNormalTradeDetail = (payload) =>
  httpClient.get(apis.getMallNormalTradeDetail(payload));
export const getMallLockpriceDepositTradeDetail = (payload) =>
  httpClient.get(apis.getMallLockpriceDepositTradeDetail(payload));
export const getMallPresellDepositTradeDetail = (payload) =>
  httpClient.get(apis.getMallPresellDepositTradeDetail(payload));
export const getMallLockpriceBalanceTradeDetail = (payload) =>
  httpClient.get(apis.getMallLockpriceBalanceTradeDetail(payload));
export const getMallPresellBalanceTradeDetail = (payload) =>
  httpClient.get(apis.getMallPresellBalanceTradeDetail(payload));
export const makeMallNormalTradeQrcode = (payload) =>
  httpClient.get(apis.makeMallNormalTradeQrcode(payload));
export const makeMallLockpriceDepositTradeQrcode = (payload) =>
  httpClient.get(apis.makeMallLockpriceDepositTradeQrcode(payload));
export const makeMallPresellDepositTradeQrcode = (payload) =>
  httpClient.get(apis.makeMallPresellDepositTradeQrcode(payload));
export const makeMallLockpriceBalanceTradeQrcode = (payload) =>
  httpClient.get(apis.makeMallLockpriceBalanceTradeQrcode(payload));
export const makeMallNormalTradeWechatQrcode = (payload) =>
  httpClient.get(apis.makeMallNormalTradeWechatQrcode(payload));
export const makeMallLockpriceDepositTradeWechatQrcode = (payload) =>
  httpClient.get(apis.makeMallLockpriceDepositTradeWechatQrcode(payload));
export const makeMallPresellDepositTradeWechatQrcode = (payload) =>
  httpClient.get(apis.makeMallPresellDepositTradeWechatQrcode(payload));
export const makeMallLockpriceBalanceTradeWechatQrcode = (payload) =>
  httpClient.get(apis.makeMallLockpriceBalanceTradeWechatQrcode(payload));
export const makeMallNormalTradePaypal = (payload) =>
  httpClient.get(apis.makeMallNormalTradePaypal(payload));
export const makeMallLockpriceDepositTradePaypal = (payload) =>
  httpClient.get(apis.makeMallLockpriceDepositTradePaypal(payload));
export const makeMallPresellDepositTradePaypal = (payload) =>
  httpClient.get(apis.makeMallPresellDepositTradePaypal(payload));
export const makeMallLockpriceBalanceTradePaypal = (payload) =>
  httpClient.get(apis.makeMallLockpriceBalanceTradePaypal(payload));
